export default "__VITE_ASSET__Bdr2sO3S__"